<script>
import axios from '../../shared/axios';
import { Line } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  extends: Line,
  props: ['height', 'width'],
  created() {
    this.fetchActiveUsers().then(r => {});
  },
  mounted() {
    const days = [...Array(8).keys()];
    days.shift();
    days.reverse();
    const verboseDays = [];
    for (const i in days) {
      verboseDays.push(
        moment()
          .subtract(days[i], 'd')
          .format('dddd, [the] Do')
      );
    }

    const datasets3 = [
      {
        label: 'Abandoned sessions',
        backgroundColor: 'rgba(255,255,255,.2)',
        borderColor: 'rgba(255,255,255,.55)',
        data: [0, 0, 0, 0, 0, 0, 0] // [78, 81, 80, 45, 34, 12, 40]
      }
    ];
    this.renderChart(
      {
        labels: verboseDays,
        datasets: datasets3
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 2
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    );
  },
  computed: {
    ...mapGetters('dashboard', ['getTestTakersOnline'])
  },
  methods: {
    ...mapActions('dashboard', ['fetchActiveUsers'])
  }
};
</script>
